import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	barWrapper: {
		backgroundColor: theme.flashDeal.background.color,
		color: theme.flashDeal.foreground.color,
		padding: `${theme.spacing.xxsmall} ${theme.spacing.xsmall}`,
		display: 'grid',
		gridTemplateColumns: 'repeat(2, 1fr)',
	},
	rounded: {
		borderRadius: theme.borderRadius.rounded,
	},
	priceCard: {
		[getFromBreakpoint('md')]: {
			borderTopLeftRadius: theme.borderRadius.rounded,
			borderTopRightRadius: theme.borderRadius.rounded,
		},
	},
	squared: {
		borderRadius: theme.borderRadius.squared,
	},
	barTitle: {
		display: 'flex',
		justifyContent: 'left',
		alignItems: 'center',
		gap: theme.spacing.tiny,
		whiteSpace: 'nowrap',
	},
	barTitleTitle: {
		whiteSpace: 'nowrap',
	},
	countdown: {
		display: 'flex',
		justifyContent: 'right',
		alignItems: 'center',
	},
}));
